import Spinner from 'components/UI/V3/Spinner';
import { FunctionComponent } from 'react';
import styles from './PayoutProcessingBanner.module.scss';

export const PayoutProcessingBanner: FunctionComponent = () => {
    return (
        <div className={styles.root}>
            <div className={styles.spinner}>
                <Spinner
                    size={18}
                    color="#000000"
                />
            </div>
            <p className={styles.text}>
                Your payout is being processed. It may take a few seconds to appear in payout history.
            </p>
        </div>
    );
};

export default PayoutProcessingBanner;
